import React from "react";
import cx from "classnames";
import { upperFirst } from "lodash-es";

import styles from "./text.module.scss";
import { polymorphic } from "../utils";

const tagVariantMap = {
  abbr: "body4",
  div: "body4",
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  label: "body4",
  p: "body4",
  span: "body4"
};

export namespace Text {
  export type Props = React.HTMLAttributes<HTMLElement> & {
    alignment?: "left" | "center" | "right";
    as?:
      | "abbr"
      | "div"
      | "h1"
      | "h2"
      | "h3"
      | "h4"
      | "h5"
      | "h6"
      | "label"
      | "p"
      | "span";
    theme?: "danger" | "default" | "muted" | "primary" | "secondary";
    variant?:
      | "body1"
      | "body2"
      | "body3"
      | "body4"
      | "h1"
      | "h2"
      | "h3"
      | "h4"
      | "h5"
      | "h6";
    weight?: "bold" | "medium" | "regular";
  };
}

export const Text = polymorphic("span")<Text.Props>(
  React.forwardRef(function RefForwardingText(
    {
      as: Component,
      alignment,
      className,
      theme,
      variant = tagVariantMap[Component] as Text.Props["variant"],
      weight,
      ...props
    },
    ref: React.Ref<any>
  ): JSX.Element {
    const classList = cx(
      className,
      styles.text,
      styles[`textAlign${upperFirst(alignment)}` as keyof typeof styles],
      styles[`text${upperFirst(theme)}` as keyof typeof styles],
      styles[`text${upperFirst(variant)}` as keyof typeof styles],
      styles[`text${upperFirst(weight)}` as keyof typeof styles]
    );

    return <Component {...props} className={classList} ref={ref} />;
  })
);
